import { ComponentSingleStyleConfig } from '@chakra-ui/react'

export const Divider: ComponentSingleStyleConfig = {
  baseStyle: {
    borderColor: 'brand.gainsboro',
  },
}
